/**
 * Created by pajicv on 10/25/18.
 */
import React from 'react';
import { Paper, Slide, withStyles, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import onClickOutside from "react-onclickoutside";
import { MAIN_COLOR } from '../../firebase-config';

const styles = theme => ({
    paper: {
        background: '#fff',
        width: '98%',
        position: 'fixed',
        top: 100,
        bottom: 5,
        left: '1%',
        opacity: 1,
        zIndex: 198
    },
    container: {
        width: '100%',
        height: '100%',
        overflow: 'auto',
        opacity: 1
    },
    fab: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    fabText: {
        color: MAIN_COLOR,
        fontSize: 22
    }
});

class OverlayLevel1 extends React.Component {

    handleClickOutside = evt => {
        const { onClickOutsideOverlay } = this.props;
        console.log(evt.target);
        onClickOutsideOverlay();
    };

    render() {
        const { props: { classes, open, onClick, children, onClose, dontShow } } = this;
        return (
            <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                <Paper className={classes.paper} onClick={onClick} elevation={24}>
                    {dontShow !== true &&
                        <React.Fragment>
                            <Button className={classes.fab} onClick={onClose}>
                                <CloseIcon />
                            </Button>
                        </React.Fragment>
                    }
                    <div className={classes.container}>
                        {children}
                    </div>
                </Paper>
            </Slide>
        )
    }

}

export default withStyles(styles)(onClickOutside(OverlayLevel1));



// WEBPACK FOOTER //
// ./src/components/Overlay/OverlayLevel1.js